<template>
    <div class="add-group-course-components">
        <el-dialog
            :visible.sync="visible"
            :title="$t('Lesson.add')"
            left>
            <el-form
                ref="form"
                :model="form"
                :rules="rules"
                :status-icon="true"
                label-position="right"
                label-width="90px"
                label-suffix=":">
                <el-form-item prop="storeId" :label="$t('Lesson.store')">
                    <el-select
                        class="pr-2 reception-store"
                        v-model="form.storeId"
                        @change="changeStore"
                        :placeholder="$t('Lesson.choose_store')">
                        <el-option
                            v-for="(item, index) in stores"
                            :key="`${index}-${item.id}`"
                            :label="item.name"
                            :value="Number(item.id)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="placeId" :label="$t('Lesson.place')">
                    <el-select
                        class="pr-2 reception-store"
                        v-model="form.placeId"
                        :placeholder="$t('Common.please_choose')">
                        <el-option
                            v-for="(item, index) in places"
                            :key="`${index}-${item.id}`"
                            :label="item.name"
                            :value="Number(item.id)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Course.time')" prop="lessonTime">
                    <el-time-select
                        v-model="form.lessonTime"
                        :default-value="time"
                        :picker-options="{
                            start: '00:00',
                            step: '00:05',
                            end: '23:45'
                        }">
                    </el-time-select>
                </el-form-item>
                <div v-for="(item, index) in weeks" :key="index">
                    <div class="add-course-item flex items-center">
                        <div class="add-course-item-title">
                            <span v-if="index == 0">{{ `${$t('Week.mon')}(${item.lessonDate})` }}</span>
                            <span v-if="index == 1">{{ `${$t('Week.tues')}(${item.lessonDate})` }}</span>
                            <span v-if="index == 2">{{ `${$t('Week.wed')}(${item.lessonDate})` }}</span>
                            <span v-if="index == 3">{{ `${$t('Week.thur')}(${item.lessonDate})` }}</span>
                            <span v-if="index == 4">{{ `${$t('Week.fri')}(${item.lessonDate})` }}</span>
                            <span v-if="index == 5">{{ `${$t('Week.satu')}(${item.lessonDate})` }}</span>
                            <span v-if="index == 6">{{ `${$t('Week.sun')}(${item.lessonDate})` }}</span>
                        </div>
                        <div class="add-course-item-lessons">
                            <el-select
                                class="pr-2"
                                v-model="item.lessonId"
                                @change="fetchDetails(index)"
                                :placeholder="$t('Common.please_choose')">
                                <el-option
                                    v-for="(item, iidex) in lessons"
                                    :key="iidex"
                                    :label="item.name"
                                    :value="Number(item.id)">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="add-course-item-coach">
                            <!-- v-on:change="searchText = null" -->
                            <el-select
                                class="pr-2"
                                v-on:change="weeks[index].searchText = null"
                                v-model="item.coachId"
                                :placeholder="$t('Common.choose_coach')">
                                <input
                                    class="add-course-coach"
                                    type="text"
                                    @input="inpu(index)"
                                    v-model="weeks[index].searchText" >
                                <el-option
                                    v-for="(item, iindex) in weeks[index].coachs"
                                    :key="iindex"
                                    :label="item.nickname"
                                    :value="Number(item.id)"
                                    :disabled="!item.id">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="add-course-appoint flex items-center">
                            <el-radio
                                v-model="item.limit"
                                label="0">{{ $t('Lesson.limi') }}</el-radio>
                            <el-radio
                                v-model="item.limit"
                                label="1">
                                <el-input
                                    class="add-course-totalAmt"
                                    v-model="item.totalAmt"
                                    :placeholder="$t('Lesson.appoint_count')">
                                </el-input>
                            </el-radio>
                        </div>
                    </div>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button
                    @click="confirm"
                    type="primary"
                    >{{ $t('Common.submit') }}</el-button>
                <span class="pl-8 add-course-tips">{{ $t('Card.ps') }}</span>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { Dialog, TimeSelect, Radio } from 'element-ui';
import timeMixin from '@/mixins/timeMixin.js';
import filterRole from '@/mixins/filterRole.js';

export default {
    components: {
        ElDialog: Dialog,
        ElTimeSelect: TimeSelect,
        ElRadio: Radio,
    },
    mixins: [timeMixin, filterRole],
    data() {
        return {
            visible: false,
            form: {
                storeId: null,
                placeId: null,
                lessonTime: null,
                items: [],
            },
            rules: {
                storeId: { type: 'number', required: true },
                placeId: { type: 'number', required: true, message: this.$t('Lesson.choose_place') },
                lessonTime: { type: 'string', required: true, message: this.$t('Lesson.choose_time')},
            },
            stores: [],
            places: [],
            weeks: [],
            coachs: [],
            lessons: [],
            coachList: [
                { coachs: [] },
                { coachs: [] },
                { coachs: [] },
                { coachs: [] },
                { coachs: [] },
                { coachs: [] },
                { coachs: [] },
            ],
            time: null,
        };
    },
    watch: {
        visible(val) {
            if (!val) {
                this.resetForm();
            }
        },
    },
    methods: {
        filterTime() {
            const date = new Date();
            let hours = date.toTimeString().substr(0, 2);
            let minutesI = date.toTimeString().substr(3, 1);
            let minutesII = date.toTimeString().substr(4, 1);
            if (minutesII > 0 && minutesII < 5) {
                minutesII = 5;
            } else if (minutesII > 5) {
                if (minutesI < 5) {
                    minutesI = Number(minutesI) + 1;
                } else {
                    hours = Number(hours) + 1;
                    minutesI = 0;
                }
                minutesII = 0;
            }
            this.time = `${hours}:${minutesI}${minutesII}`;
        },
        resetForm() {
            this.$refs.form.resetFields();
        },
        open(storeId, date) {
            // 获取当前周
            const weeks = this.handleWeekly(new Date(date));
            this.weeks = weeks.eachDay.map(el => {
                const item = {
                    lessonDate: el.date,
                    lessonId: null,
                    coachId: null,
                    totalAmt: null,
                    limit: '0',
                    searchText: null,
                };
                return item;
            });
            this.form.storeId = storeId;
            this.fetchStore();
            this.fetchLessons();
            this.fetchPlace();
            this.fetchCoach();
            this.filterTime();
            this.visible = true;
        },
        // 门店
        fetchStore() {
            API.get('store/list').then(res => {
                this.stores = res;
            });
        },
        changeStore() {
            this.fetchPlace();
            this.fetchLessons();
        },
        // 场地
        fetchPlace() {
            const id = this.form.storeId;
            API.get(`store/${id}/place/list`, {
                params: {
                    active: true,
                },
            }).then(res => {
                this.places = res;
            });
        },
        // 获取团课课程列表
        fetchLessons() {
            const query = {
                active: true,
                storeId: this.form.storeId,
            };
            API.get('lesson/team/list', {
                params: query,
            }).then(res => {
                this.lessons = res;
            });
        },
        // 获取详情
        fetchDetails(index) {
            // const lessonId = this.weeks[index].lessonId;
            const {lessonId} = this.weeks[index];
            API.get(`lesson/team/${lessonId}`).then(res => {
                const {storeId} = this.form;
                const coachs = [];
                if (res.storeIds.includes(storeId)) {
                    this.coachs.map(el => {
                        res.coachIds.map(item => {
                            if (item === el.id) coachs.push(el);
                            return item;
                        });
                        return el;
                    });
                }
                this.$set(this.weeks[index], 'coachs', coachs);
                this.coachList[index].coachs = coachs;
            });
        },
        // 获取所有教练
        async fetchCoach() {
            this.coachs = await this.filterRole(10);
        },
        // 搜索
        inpu(index) {
            const value = this.weeks[index].searchText;
            if (!value) this.weeks[index].coachs = this.coachList[index].coachs;
            const arr = this.coachList[index].coachs.filter(item =>
                item.nickname.toLowerCase().indexOf(value.toLowerCase()) > -1);
            this.weeks[index].coachs = arr.length ? arr : [{id: null, nickname: this.$t('Common.data_not_found')}];
        },
        confirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return false;

                this.form.items = [];
                // 数据处理
                this.weeks.map(el => {
                    if (el.coachId && el.lessonId) {
                        const item = {
                            coachId: el.coachId,
                            lessonDate: el.lessonDate,
                            lessonId: el.lessonId,
                            totalAmt: Number(el.limit) === 0 ? 0 : el.totalAmt,
                        };
                        this.form.items.push(item);
                    }
                    return el;
                });
                this.filterCoach();
            });
        },
        // 筛选教练是否没空
        filterCoach() {
            const query = {};
            query.lessonTime = this.form.lessonTime;
            query.placeId = this.form.placeId;
            query.storeId = this.form.storeId;
            this.form.items.map((i, index) => {
                query[`items[${index}].coachId`] = i.coachId;
                query[`items[${index}].lessonDate`] = i.lessonDate;
                query[`items[${index}].lessonId`] = i.lessonId;
                query[`items[${index}].totalAmt`] = i.totalAmt;
                return query;
            });
            API.get('lesson/team/schedule/check-coach-time', {
                params: query,
            }).then(() => {
                this.postData();
            }).catch(err => {
                console.log(err);
            });
        },
        postData() {
            API.post('lesson/team/schedule', this.form).then(() => {
                $ele.$message.success(this.$t('Message.success'));
                this.$emit('fetchGroup');
                this.visible = false;
            });
        },
    },
};
</script>

<style lang="scss">
.add-group-course-components {
    .el-dialog {
        width: 710px;
        margin: 0 !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .el-dialog--center .el-dialog__body {
        padding: 25px 25px 0;
    }
    .add-course-item-title {
        margin: 0 35px 15px 10px;
        height: 32px;
        line-height: 32px;
    }
}
.add-course-coach {
    width: calc(100% - 40px);
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    height: 28px;
    outline: none;
}
.add-course-item-lessons,
.add-course-item-coach {
    margin-right: 14px;

    .el-input__inner {
        width: 120px;
    }
}
.add-course-totalAmt {
    width: 90px;
}
.add-course-tips {
    font-size: 12px;
    color: #de2d0f;
}
</style>
